import React from 'react';
import './MoreBubblesConfirmation.css';

const MoreBubblesConfirmation = ({ 
  bubblesShown, 
  totalThoughts, 
  onShowMore, 
  onDecline 
}) => {
  if (bubblesShown < 4 || totalThoughts <= 4) return null;

  return (
    <div className="more-bubbles-confirmation">
      <div className="confirmation-content">
        <h3>✨ You've seen {bubblesShown} inspiring thoughts! ✨</h3>
        <p>Take a moment to reflect on what you've learned, or use the back arrow to revisit any previous thoughts.</p>
        <p className="subtitle">Would you like to see more inspiring thoughts?</p>
        <div className="confirmation-buttons">
          <button 
            className="yes-button"
            onClick={onShowMore}
          >
            Yes, show me more! 🌟
          </button>
          <button 
            className="no-button"
            onClick={onDecline}
          >
            No, I'll reflect on these 😊
          </button>
        </div>
        <div className="navigation-hint">
          <span className="hint-text">💡 Use the ← back arrow to revisit previous thoughts</span>
        </div>
      </div>
    </div>
  );
};

export default MoreBubblesConfirmation;
